export default "__VITE_ASSET__CMISEdKt__"